/**
 * 统一语言规则
 * @param {*} 
 * @return str
 */
export const language = (str) => {
    let result = str
    
    switch (str) {
        case 'zh-CN':
            result = 'zh'
            break;
        case 'zh-TW':
            result = 'zh_tw'
            break;
        default:
            result = 'en'
            break;
    }
    return result;
}